<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/menu_cp_pack') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <FilterCp hclass="max-width-120" v-model="formFilter.cp_id" @load="cpLoad"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="cp_id" :label="$strings('word/cp_id')">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.cp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="cp_id" :label="$strings('word/cp')">
                    <template slot-scope="scope">
                        {{ mapping.cps[scope.row.cp_id].cp_name }}
                    </template>
                </el-table-column>
                <el-table-column prop="country" :label="$strings('word/country')">
                    <template slot-scope="scope">
                        <span>{{ countryName(scope.row.country) }} ({{ scope.row.country }})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" :label="$strings('word/amount')"></el-table-column>
                <el-table-column prop="price" :label="$strings('word/price')"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column>

                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="$strings('word/create')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('word/cp')" prop="cp_id">
                        <el-select v-model="editForm.cp_id">
                            <el-option v-for="(item, idx) in options.cps" :label="item.label" :value="item.value"
                                       :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$strings('word/country')" prop="country">
                        <el-select v-model="editForm.country">
                            <el-option v-for="(item, idx) in options.cts" :label="item.label" :value="item.value"
                                       :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$strings('word/amount')" prop="amount">
                        <el-input v-model="editForm.amount" clearable
                                  :placeholder="$strings('spsite/cppack/amount_tips')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/price')" prop="amount">
                        <el-input v-model="editForm.price" clearable
                                  :placeholder="$strings('spsite/cppack/price_tips')"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {API_STATUS_CODE, CTS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {SpSiteCpPackCreate, SpSiteCpPackRead} from "@/api/spsite/api";
import FlagByCountryCode from "@/utils/flag";
import {UnixToDateFull} from "../../../utils/time";
import FilterCp from "../../../components/filter/cp";

export default {
    name: "spsite-cppack",
    components: {FilterCp},
    data() {
        return {
            loading: true,
            isEdit: false,
            saving: false,
            editForm: {},
            formFilter: {},
            pagination: {
                total: 0,
                page: 1,
                size: 12,
            },
            tableData: [],
            dialogVisible: false,
            rules: {
                amount: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ],
                cp_id: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ],
                country: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ]
            },
            options: {
                cps: [],
                cts: CTS,
            },
            mapping: {cps: {}}
        }
    },
    mounted() {
        this.prepare();
        this.refreshData();
    },
    computed: {},
    methods: {
        cpLoad(cps) {
            this.options.cps = [];
            cps.forEach((item) => {
                this.options.cps.push({label: item.cp_name, value: item.cp_id});
            })
            this.mapping.cps = [];
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item;
            })
        },
        countryName(ct) {
            let country = '/';
            this.options.cts.forEach((item) => {
                if (item.value === ct) {
                    country = FlagByCountryCode(item.value) + " " + item.label + " ";
                }
            })
            return country;
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onCreate() {
            this.editForm = {};
            this.dialogVisible = true;
        },
        onSaveEdit() {
            this.saving = true;
            this.editForm.amount = 1 * this.editForm.amount;
            SpSiteCpPackCreate(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.refreshData();
                }
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.page = this.pagination.page;
            this.formFilter.size = this.pagination.size;
            SpSiteCpPackRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        prepare() {

        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>